import Markdown from "@/components/Markdown";
import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { HEALTH_DOT, DOT_LEGEND } from "@/lib/health";

export function CollapseGroup({ id, testid, label, color, count, children, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="mt-2 first:mt-0">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-wide mb-1.5 hover:opacity-75 transition-opacity"
        style={{ color }}
        title={open ? "Collapse this group" : "Expand this group"}
        data-testid={testid || `group-${id}`}
      >
        {open ? <ChevronDown className="h-3.5 w-3.5 print-hide" /> : <ChevronRight className="h-3.5 w-3.5 print-hide" />}
        {label} ({count})
      </button>
      {open && children}
    </div>
  );
}

export function HealthDot({ health, title }) {
  return <span className="h-2.5 w-2.5 rounded-full shrink-0 inline-block" style={{ background: HEALTH_DOT[health] || HEALTH_DOT.gray }} title={title || health} data-testid={`health-dot-${health}`} />;
}

export function DotLegend() {
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-1 mb-2 text-[11px] text-muted-foreground" data-testid="dot-legend">
      {DOT_LEGEND.map(([k, l]) => (
        <span key={k} className="inline-flex items-center gap-1"><span className="h-2 w-2 rounded-full" style={{ background: HEALTH_DOT[k] }} /> {l}</span>
      ))}
    </div>
  );
}

export function EditableLine({ id, text, editMode, overrides, onOverride, className = "" }) {
  const val = overrides[id] !== undefined ? overrides[id] : text;
  if (editMode) {
    return <input className="w-full bg-amber-50 border border-amber-300 rounded px-1.5 py-0.5 text-sm" value={val} onChange={(e) => onOverride(id, e.target.value)} data-testid={`edit-line-${id}`} />;
  }
  return <span className={className}>{val}</span>;
}

export function splitMarkdownSections(md) {
  const lines = (md || "").split("\n");
  const segs = [];
  let cur = { heading: null, lines: [] };
  lines.forEach((ln) => {
    const m = ln.match(/^#{1,4}\s+(.*)/);
    if (m) { segs.push(cur); cur = { heading: m[1].trim().replace(/[*_`]/g, ""), lines: [ln] }; }
    else cur.lines.push(ln);
  });
  segs.push(cur);
  return segs.filter((s) => s.heading !== null || s.lines.join("").trim());
}

export function execHeadings(md) {
  return splitMarkdownSections(md).map((s) => s.heading).filter(Boolean);
}

export function ExecFiltered({ md, hidden = [] }) {
  const segs = splitMarkdownSections(md).filter((s) => !s.heading || !hidden.includes(s.heading));
  return <Markdown text={segs.map((s) => s.lines.join("\n")).join("\n")} />;
}
